// extracted by mini-css-extract-plugin
export default {"row":"bio_row__+bzgf","placeholder":"bio_placeholder__s9sp7","bio":"bio_bio__2op0o"};